import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import logo from '../asset/logo/LOGO_ORANGE.svg';
import MobileLayout from '../MobileLayout';
import BasicCard from '../home-section/BasicCard';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '40vh',
  },
  retry: {
    display: 'block',
    margin: '1.5rem auto 0',
    fontFamily: 'Roboto',
    fontWeight: 700,
    fontSize: '1.1rem',
    color: '#EB6608',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
  },
}));

/**
 * Why the participant cannot go on, in words that fit: the breef is closed, it has not opened yet, the link has
 * run out, or the phone could not reach us (then there is a button to try again). Before, every case said
 * "the link has expired or you have already played", also when the network was the problem.
 */
export const CheckBreefExpiryOrSubmitted = () => {
  const [t] = useTranslation('global');
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();
  const params = new URLSearchParams(location.search);
  const reason = params.get('reason') || 'expired';
  const date = params.get('date');
  const opens = date ? new Date(date).toLocaleDateString('da-DK', { day: 'numeric', month: 'long' }) : '';
  const text =
    reason === 'closed' ? t('introduction.breefClosed')
    : reason === 'upcoming' ? t('introduction.breefUpcoming', { date: opens })
    : reason === 'error' ? t('introduction.connectionFailed')
    : t('introduction.noAccess');
  const retry = () => {
    const token = sessionStorage.getItem('BreefAccesstoken');
    if (token) navigate(`/breefInvite?token=${encodeURIComponent(token)}`);
    else window.location.reload();
  };
  return (
    <MobileLayout>
      <div className={classes.container}>
        <img height={'40%'} src={logo} alt="Breefer" />
      </div>
      <BasicCard message={text} />
      {reason === 'error' && (
        <button type="button" className={classes.retry} onClick={retry}>
          {t('introduction.tryAgain')}
        </button>
      )}
    </MobileLayout>
  );
};
